/**
 * Helper composable to show global loading state
 * @param watchSources If watchSources are passed, the loading state reacts to them and is true if any of them is true.
 */
export default function useLoading(watchSources: Ref[] = []) {
    const isLoading = useState<boolean>('loading_state', () => false);

    if (watchSources.length) {
        watch(watchSources, (values) => {
            isLoading.value = values.some(Boolean);
        }, { immediate: true });
    }

    return {
        isLoading,
    };
}
